export const capitalizeFirst = (str: string): string =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : str;
